import gql from 'graphql-tag'
export default gql`
  query UniqueBosses($token: String!, $excludeOrganisationIds: [Int]) {
    viewer(token: $token) {
      id
      ipPersonId
      uniqueBosses(excludeOrganisationIds: $excludeOrganisationIds) {
        bossId
        firstName
        surName
        count
      }
    }
  }
`
